<template>
  <div class="wrap">
    <div class="module-filter">
      <el-form
        ref="listQueryFormRef"
        :inline="true"
        :model="listQuery"
        label-width="80px"
      >
        <el-form-item label="统计维度" prop="code">
          <el-select
            v-model="listQuery.code"
            placeholder="请选择"
            style="width: 220px"
            size="small"
          >
            <el-option
              v-for="item in enumOptions"
              :key="item.code"
              :label="item.values"
              :value="item.code"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="款号" prop="styleNumberList">
          <el-select
            v-model="listQuery.styleNumberList"
            placeholder="请选择"
            style="width: 220px"
            size="small"
            multiple
            clearable
            filterable
            collapse-tags
          >
            <el-option
              v-for="item in styleOptions"
              :key="item.code"
              :label="item.code"
              :value="item.code"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="供应商" prop="supperCodeList">
          <el-select
            v-model="listQuery.supperCodeList"
            placeholder="请选择"
            style="width: 220px"
            size="small"
            multiple
            clearable
            filterable
            collapse-tags
          >
            <el-option
              v-for="(item, index) in supperOptions"
              :key="index"
              :label="item.code + '-' + item.value"
              :value="item.code"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="网点" prop="storeCodeList">
          <el-select
            v-model="listQuery.storeCodeList"
            placeholder="请选择"
            style="width: 220px"
            size="small"
            multiple
            clearable
            filterable
            collapse-tags
          >
            <el-option
              v-for="(item, index) in storeOptions"
              :key="index"
              :label="item.code + '-' + item.value"
              :value="item.code"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="分类" prop="productRemarkList">
          <el-select
            v-model="listQuery.productRemarkList"
            placeholder="请选择"
            style="width: 220px"
            size="small"
            multiple
            clearable
            filterable
            collapse-tags
          >
            <el-option
              v-for="item in productRemarkOptions"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="起止时间" prop="code">
          <el-date-picker
            v-model="listQuery.timeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 360px;"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            icon="Search"
            size="small"
            @click="onSearch"
          >
            查询
          </el-button>
          <el-button icon="Refresh" size="small" @click="onReset">
            重置
          </el-button>

          <el-button
            :loading="downloadLoading"
            type="primary"
            size="small"
            @click="onExportInventory"
          >
            导出款式库存
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="module-total">
      <div
        class="module-total-item"
        @click="
          () => {
            $refs.DialogLoginRef.handleShow({
              ...listQuery,
            })
          }
        "
      >
        <el-statistic
          group-separator=","
          :value="loginCount"
          title="登录人数"
          :value-style="{
            fontSize: '22px',
            color: '#ec9368',
            cursor: 'pointer',
          }"
        ></el-statistic>
      </div>

      <div
        class="module-total-item"
        v-for="item in orderList"
        :key="item.prop"
        @click="
          () => {
            $refs.DialogOrderRef.handleShow({
              ...listQuery,
              orderStatus: item.prop,
            })
          }
        "
      >
        <el-statistic
          group-separator=","
          :value="orderData[item.prop]"
          :title="item.label"
          :value-style="{
            fontSize: '22px',
            color: '#ec9368',
            cursor: 'pointer',
          }"
        ></el-statistic>
      </div>
    </div>

    <div class="module-total">
      <div
        class="module-total-item"
        @click="
          () => {
            $refs.DialogOrgRef.handleShow({
              ...listQuery,
            })
          }
        "
      >
        <el-statistic
          group-separator=","
          :value="orgNumber"
          title="下单网点数"
          :value-style="{
            fontSize: '22px',
            color: '#ec9368',
            cursor: 'pointer',
          }"
        ></el-statistic>
      </div>

      <div
        class="module-total-item"
        v-for="item in productList"
        :key="item.prop"
        @click="
          () => {
            $refs.DialogProductRef.handleShow({
              ...listQuery,
              orderStatus: item.prop,
            })
          }
        "
      >
        <el-statistic
          group-separator=","
          :value="productData[item.prop]"
          :title="item.label"
          :value-style="{
            fontSize: '22px',
            color: '#ec9368',
            cursor: 'pointer',
          }"
        ></el-statistic>
      </div>
    </div>

    <div class="module-table">
      <el-table
        class="table-entity"
        :data="dataList"
        border
        :header-cell-style="{ backgroundColor: '#ec9368', color: '#000' }"
        max-height="500"
      >
        <el-table-column align="center" prop="name" :label="codeLabel" />
        <el-table-column align="right" prop="totalNumber" label="总件数" />
        <el-table-column align="right" prop="waitPay" label="待支付件数" />
        <el-table-column align="right" prop="accept" label="已支付件数" />
        <el-table-column align="right" prop="production" label="已送检件数" />
        <el-table-column align="right" prop="connected" label="已入网件数" />
        <el-table-column align="right" prop="shippedOut" label="已发货件数" />
        <el-table-column align="right" prop="success" label="已完成件数" />
        <el-table-column align="right" prop="cancel" label="已取消件数" />
      </el-table>

      <div class="table-pagination">
        <el-pagination
          v-if="!!total"
          @size-change="
            (val) => {
              this.listQuery.size = val
              this.getList()
            }
          "
          @current-change="
            (val) => {
              this.listQuery.current = val
              this.getList()
            }
          "
          :current-page="listQuery.current"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="listQuery.size"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
          background
        ></el-pagination>
      </div>
    </div>

    <DialogOrder
      ref="DialogOrderRef"
      :storeOptions="storeOptions"
      :supperOptions="supperOptions"
      :styleOptions="styleOptions"
      :productRemarkOptions="productRemarkOptions"
    />

    <DialogProduct
      ref="DialogProductRef"
      :storeOptions="storeOptions"
      :supperOptions="supperOptions"
      :styleOptions="styleOptions"
      :productRemarkOptions="productRemarkOptions"
    />

    <DialogLogin ref="DialogLoginRef" />

    <DialogOrg ref="DialogOrgRef" />
  </div>
</template>

<script>
import * as ApiAnalysis from '@/api/analysis'
import DialogOrder from './components/DialogOrder'
import DialogProduct from './components/DialogProduct'
import DialogLogin from './components/DialogLogin'
import DialogOrg from './components/DialogOrg'

export default {
  name: 'Analysis',
  components: {
    DialogOrder,
    DialogProduct,
    DialogLogin,
    DialogOrg,
  },
  data() {
    return {
      codeLabel: '',
      listQuery: {
        code: '01',
        styleNumberList: [],
        supperCodeList: [],
        storeCodeList: [],
        productRemarkList: [],
        timeRange: [],
        startTime: null,
        endTime: null,
        current: 1,
        size: 100,
      },
      orderList: [
        {
          label: '订单总数',
          prop: 'totalNumber',
        },
        {
          label: '待支付订单',
          prop: 'waitPay',
        },
        {
          label: '已支付订单',
          prop: 'accept',
        },
        {
          label: '已送检订单',
          prop: 'production',
        },
        {
          label: '已入网订单',
          prop: 'connected',
        },
        {
          label: '已发货订单',
          prop: 'shippedOut',
        },
        {
          label: '已完成订单',
          prop: 'success',
        },
        {
          label: '已取消订单',
          prop: 'cancel',
        },
      ],
      orderData: {
        accept: 0,
        cancel: 0,
        connected: 0,
        production: 0,
        shippedOut: 0,
        success: 0,
        totalNumber: 0,
        waitPay: 0,
      },
      productList: [
        {
          label: '总件数',
          prop: 'totalNumber',
        },
        {
          label: '待支付件数',
          prop: 'waitPay',
        },
        {
          label: '已支付件数',
          prop: 'accept',
        },
        {
          label: '已送检件数',
          prop: 'production',
        },
        {
          label: '已入网件数',
          prop: 'connected',
        },
        {
          label: '已发货件数',
          prop: 'shippedOut',
        },
        {
          label: '已完成件数',
          prop: 'success',
        },
        {
          label: '已取消件数',
          prop: 'cancel',
        },
      ],
      productData: {
        accept: 0,
        cancel: 0,
        connected: 0,
        production: 0,
        shippedOut: 0,
        success: 0,
        totalNumber: 0,
        waitPay: 0,
      },
      dataList: [],
      total: 0,
      enumOptions: [],
      storeOptions: [],
      supperOptions: [],
      styleOptions: [],
      productRemarkOptions: [],
      loginCount: 0,
      orgNumber: 0,
      downloadLoading: false,
    }
  },
  mounted() {
    this.getOptions()
  },
  methods: {
    onExportInventory() {
      this.downloadLoading = true
      ApiAnalysis.exportInventory({
        filename: `款式库存.xlsx`,
      }).finally(() => {
        this.downloadLoading = false
      })
    },
    async getOptions() {
      const [res1, res2, res3, res4, res5] = await Promise.all([
        ApiAnalysis.getEnumOptions(),
        ApiAnalysis.getStoreOptions(),
        ApiAnalysis.getSupperOptions(),
        ApiAnalysis.getStyleOptions(),
        ApiAnalysis.getProductRemarkOptions(),
      ])

      this.enumOptions.splice(0, this.enumOptions.length)
      this.storeOptions.splice(0, this.storeOptions.length)
      this.supperOptions.splice(0, this.supperOptions.length)
      this.styleOptions.splice(0, this.styleOptions.length)
      this.productRemarkOptions.splice(0, this.productRemarkOptions.length)

      this.enumOptions.push(...res1.data)
      this.storeOptions.push(...res2.data)
      this.supperOptions.push(...res3.data)
      this.styleOptions.push(...res4.data)
      this.productRemarkOptions.push(...res5.data)

      this.listQuery.code = this.enumOptions[0].code
      this.codeLabel = this.enumOptions[0].values
      this.onSearch()
    },

    getTotal() {
      ApiAnalysis.getTotal({
        ...this.listQuery,
        startTime: this.listQuery.timeRange?.[0],
        endTime: this.listQuery.timeRange?.[1],
      }).then((res) => {
        this.orderData = res.data
      })
      ApiAnalysis.getTotal2({
        ...this.listQuery,
        startTime: this.listQuery.timeRange?.[0],
        endTime: this.listQuery.timeRange?.[1],
      }).then((res) => {
        this.productData = res.data
      })

      ApiAnalysis.getLoginCount({
        ...this.listQuery,
        startTime: this.listQuery.timeRange?.[0],
        endTime: this.listQuery.timeRange?.[1],
      }).then((res) => {
        this.loginCount = +res.data
      })

      ApiAnalysis.getOrgNumber({
        ...this.listQuery,
        startTime: this.listQuery.timeRange?.[0],
        endTime: this.listQuery.timeRange?.[1],
      }).then((res) => {
        this.orgNumber = +res.data
      })
    },

    getList() {
      ApiAnalysis.getList({
        ...this.listQuery,
        startTime: this.listQuery.timeRange?.[0],
        endTime: this.listQuery.timeRange?.[1],
      }).then((res) => {
        this.dataList.splice(0, this.dataList.length)
        this.dataList.push(...res.data.records)
        this.total = res.data.total || 0
        this.codeLabel = this.enumOptions[+this.listQuery.code - 1].values
      })
    },

    onSearch() {
      this.getList()
      this.getTotal()
    },

    onReset() {
      this.listQuery.styleNumberList = []
      this.listQuery.supperCodeList = []
      this.listQuery.storeCodeList = []
      this.listQuery.timeRange = []
      this.listQuery.productRemarkList = []
      this.listQuery.startTime = null
      this.listQuery.endTime = null
      this.getList()
      this.getTotal()
    },
  },
}
</script>

<style scoped lang="scss">
.wrap {
  padding: 10px;
  background-color: #f3f3f3;

  /deep/ .el-table .el-table__cell {
    padding: 8px 0;
  }

  .module-filter {
    display: flex;
    align-items: center;
    padding-top: 22px;
    margin-bottom: 10px;
    background: #ffffff;
  }

  .module-total {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    &-item {
      display: flex;
      flex: 1;
      align-items: center;
      padding: 10px;
      background: #ffffff;
      margin-right: 10px;
      height: 48px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .module-table {
    background: #ffffff;
    padding: 10px;

    .table-pagination {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 10px;
    }
  }
}
</style>
